module.exports = __webpack_public_path__ + "fonts/SourceHanSans-Bold.ac4d19fd.otf";